import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollText } from "lucide-react";

export default function AuditLogSection({ instructor }: { instructor: any }) {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => {
    (async () => {
      const { data } = await (supabase.from as any)("instructor_document_access_log")
        .select("*")
        .eq("instructor_id", instructor.id)
        .order("created_at", { ascending: false })
        .limit(50);
      setRows(data ?? []);
    })();
  }, [instructor.id]);

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><ScrollText className="h-4 w-4" /> Document Access Audit</CardTitle>
        <CardDescription>Every view, download, upload, replace, and delete is recorded.</CardDescription>
      </CardHeader>
      <CardContent className="text-sm">
        {rows.length === 0 && <div className="text-xs text-muted-foreground">No access recorded yet.</div>}
        <ul className="divide-y">
          {rows.map((r) => (
            <li key={r.id} className="py-2 flex flex-wrap items-center gap-2">
              <Badge variant="outline" className="uppercase">{r.action}</Badge>
              <Badge variant="secondary">{r.document_kind}</Badge>
              <span className="text-xs text-muted-foreground">{new Date(r.created_at).toLocaleString()}</span>
              <span className="text-xs text-muted-foreground truncate">
                {(r.metadata?.doc_type ? `${r.metadata.doc_type} · ` : "")}{r.metadata?.file_name ?? ""}
              </span>
              <span className="ml-auto text-xs text-muted-foreground">
                {r.actor_id ? `Admin ${String(r.actor_id).slice(0, 8)}…` : "System"}
              </span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
